import { IS_LOADING } from '@/store/types/root/actions-types';
import { TEAM_CREATE_REQUEST, TEAM_UPDATE_REQUEST, TEAM_DELETE_REQUEST, GET_TEAMS_REQUEST } from './action-types';
import {ADD_TEAMS_TO_LIST, ADD_TEAM_TO_LIST, DELETE_TEAM_FROM_LIST, UPDATE_TEAM_IN_LIST} from "./mutation-types"
import api from "@/api/api"
import showMessage from "@/utils/alert"

export default {

    [GET_TEAMS_REQUEST]: async ({  commit })=>{
        let response = {}
        try {
            response =   await api.get("/teams")
            if(response.data.statusCode === 200){
                const reponseBody = response.data.body
                commit(ADD_TEAMS_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [TEAM_CREATE_REQUEST]: async ({ commit }, body)=>{
        let response = {}
        if(body.id)
            delete body.id
            
        if(body.default_points == 0)
            delete body.default_points
        try {
            response =   await api.post("/teams", body)
            const reponseBody = response.data.body
            if(response.data.statusCode === 200){
                if("created_at_epoch" in reponseBody)
                    commit(ADD_TEAM_TO_LIST, reponseBody)
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [TEAM_UPDATE_REQUEST]: async ({state, commit }, body)=>{
        const lodash = require('lodash');
        let response = {}            
        let oldTeam = state.teamsList.filter(item=>{ return item.id == body.id})
        oldTeam = oldTeam.length > 0 ? oldTeam[0] : {}
        const bodyDifference = lodash.omitBy(body, (value, key) => oldTeam[key] === value);
        try{
            response =   await api.put("/teams/" + body.id, bodyDifference)
            if(response.data.statusCode === 200){
                if(response.data.body.message === "Team Updated."){
                    commit(UPDATE_TEAM_IN_LIST, body)
                }
            }
        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    },

    [TEAM_DELETE_REQUEST]: async ({ commit }, teamIDs)=>{
        let response = {}
        try {
            response =   await api.post("/teams/delete", {"ids": teamIDs})
            const reponseBody = response.data.body

            if(response.data.statusCode === 200){
                if(reponseBody.message === "Team(s) Deleted." )
                 commit(DELETE_TEAM_FROM_LIST, teamIDs)
            }

        } catch (err) {
            commit(IS_LOADING, false, { root: true })
        }
        return response
    }

}
